import { APP_CONSTANTS } from 'app/app.config';
import { HttpClient } from '@angular/common/http';
import { PolicyTranslation } from '@modules/private/admin/popups-manager/pages/policy-popup/types';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { User } from '@core/modules/user/models';
import { ActivationPolicyDateDTO, CheckUserPolicyDTO } from '@shared/types/dtos';

@Injectable({
  providedIn: 'root'
})
export class PolicyApiService {
  API_URL: string = APP_CONSTANTS.API_URL;

  constructor(
    private httpClient: HttpClient,
    private readonly messageService: MessageService,
    private readonly translate: TranslateService
  ) {}

  setActivationDate(data: ActivationPolicyDateDTO) {
    return this.httpClient.post(`${this.API_URL}admin/policy`, data).pipe(
      tap(() => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('form.success-post-title'),
          detail: this.translate.instant('form.success-post')
        });
      })
    );
  }

  removeActivationDate() {
    return this.httpClient.delete(`${this.API_URL}admin/policy`).pipe(
      tap(() => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('form.success-delete-title'),
          detail: this.translate.instant('form.success-delete')
        });
      })
    );
  }

  getActivationPolicyDate() {
    return this.httpClient.get<ActivationPolicyDateDTO>(`${this.API_URL}admin/policy`);
  }

  checkUserHasNewPolicy(id: number) {
    return this.httpClient.get<CheckUserPolicyDTO>(`${this.API_URL}users/${id}/policy/check`);
  }

  acceptNewPolicy(user: User) {
    return this.httpClient.post(`${this.API_URL}users/${user.id}/policy/accept`, {});
  }

  saveTranslations(data: { translation: PolicyTranslation; policyChangeId?: number }) {
    return this.httpClient.post(`${this.API_URL}admin/policy/translations`, data).pipe(
      tap(() => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('form.success-put-title'),
          detail: this.translate.instant('form.success-put')
        });
      })
    );
  }

  getTranslations() {
    return this.httpClient.get<PolicyTranslation>(`${this.API_URL}admin/policy/translations`);
  }
}
